import config from 'config'

const heapService = {

  track: ({ eventName, eventDetails }) => {
    if (typeof window.heap !== 'undefined' && typeof window.heap.track === 'function') {
      window.heap.track(eventName, eventDetails)
    }
  },

  identify: ({ userId, properties }) => {
    if (typeof window.heap !== 'undefined' && typeof window.heap.identify === 'function') {
      window.heap.identify(`${config.HEAP_ID_PREFIX}-${userId}`)
      window.heap.addUserProperties(properties)
    }
  },

  recordAddToCartEvent: ({ phone, email }) => {
    heapService.track({
      eventName: 'AddToCart',
      eventDetails: {
        phone,
        email
      }
    })
  },

  storeUserProperties: ({ phone, email, costInCents, location, planType, couponCode }) => {
    const properties = JSON.stringify({
      email,
      phone,
      costInCents,
      location,
      planType,
      couponCode
    })
    localStorage.setItem('heap.user', properties)
  },

  retrieveUserProperties: () => {
    const itemStr = localStorage.getItem('heap.user') || '{}'
    return JSON.parse(itemStr)
  },

  clearUserProperties: () => {
    localStorage.removeItem('heap.user')
  },

  recordPurchaseEvent: ({ patientId }) => {
    if (patientId) {
      const properties = heapService.retrieveUserProperties()

      heapService.identify({ userId: patientId, properties })
      heapService.track({ eventName: 'Purchase', eventDetails: properties })

      heapService.clearUserProperties()
    }
  }
}

export default heapService
